export const shorten = (array: string[], label?: string): string => {
  const len = array.length;
  if (len < 3) {
    return array.join(', ');
  }

  return `${array.slice(0, 2).join(', ')}, +${len - 2} ${label}`;
};
